exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".track__slick-track__2vOSc{display:-ms-flexbox;display:flex}", "", {"version":3,"sources":["/home/builduser/agent07/work/c8e02a04a4ed599f/src/widget/components/mobile-carousel/src/widget/components/mobile-carousel/track.styl","/home/builduser/agent07/work/c8e02a04a4ed599f/src/widget/components/mobile-carousel/track.styl"],"names":[],"mappings":"AAEA,2BACE,oBAAA,YAAA,CCDD","file":"track.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.slick-track\n  display flex\n",".slick-track {\n  display: flex;\n}\n/*# sourceMappingURL=src/widget/components/mobile-carousel/track.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"slick-track": "track__slick-track__2vOSc",
	"slickTrack": "track__slick-track__2vOSc"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/mobile-carousel/track.styl
// module id = 2566
// module chunks = 1